import { Injectable } from '@angular/core';
import { INotification } from 'src/app/domain/interfaces/notification/notification';
import { IEverflowData } from 'src/app/domain/interfaces/user/interface-user-everflow-data';
import { IUser } from '../../../domain/interfaces/user/interface-user';
import { TokenGateway } from '../../../domain/models/users/gateway/token-gateway';
import { CypherService } from '../cypher-service/cypher.service';

const token_key = 'auth-token';
const refreshtoken_key = 'auth-refresh-token';
const user_key = 'auth-user';
const notification_key = 'user-notification';
const everflow_key = 'user-everflow-data'

@Injectable({
  providedIn: 'root'
})
export class TokenService extends TokenGateway {

  constructor(private cypherService: CypherService) {
    super();
  }
  
  clearStorage(): void {
    for (const key of Object.keys(localStorage)) {
      if (!key.startsWith('mxAttempts_')) localStorage.removeItem(key);
    }
    sessionStorage.clear();
  }

  saveToken(token: string): void {
    localStorage.removeItem(token_key);
    localStorage.setItem(token_key, token ?? "");
  }

  saveRefreshToken(token: string): void {
    localStorage.removeItem(refreshtoken_key);
    localStorage.setItem(refreshtoken_key, token ?? "");
  }

  getToken(): string {
    return localStorage.getItem(token_key)!;
  }

  getRefreshToken(): string {
    return localStorage.getItem(refreshtoken_key)!;
  }

  saveNotification(notification: INotification): void {
    localStorage.removeItem(notification_key);
    localStorage.setItem(notification_key, this.cypherService.EncryptObject(JSON.stringify(notification)) ?? "");
  }
  
  getNotification(): INotification | null  {
    const notificationObj = this.cypherService.DecryptObject(localStorage.getItem(notification_key)!);
    if(notificationObj) {
      return JSON.parse(notificationObj);
    }
    return null;
  }

  saveUser(user: IUser): void {
    localStorage.removeItem(user_key);
    localStorage.setItem(user_key, this.cypherService.EncryptObject(JSON.stringify(user)) ?? "");
  }

  saveUserEverflowData(everflowData: IEverflowData): void {
    localStorage.removeItem(everflow_key);
    localStorage.setItem(everflow_key, this.cypherService.EncryptObject(JSON.stringify(everflow_key)) ?? "");
  }

  getUser(): IUser | null {
    const userObj = this.cypherService.DecryptObject(localStorage.getItem(user_key)!);
    if(userObj) {
      return JSON.parse(userObj);
    } else {
      this.clearStorage();
    }
    return null;
  }

  getUserEverflowData(): IEverflowData | null {
    const userEverflowDataObj = this.cypherService.DecryptObject(localStorage.getItem(everflow_key)!);
    if(userEverflowDataObj) {
      return JSON.parse(userEverflowDataObj);
    } else {
      this.clearStorage();
    }
    return null;
  }

  saveModel(model: string, key: string) {
    localStorage.removeItem(key);
    localStorage.setItem(key, model);
  }
  
  getModelKey(key: string) {
    return localStorage.getItem(key)!;
  }

}
